

const VendorStock = ()=>{

    //specific time
    return (
        <>vendor stock</>
    );
}

export default VendorStock;